module.exports = global["$"] = require("-!/app/node_modules/expose-loader/index.js?jQuery!/app/node_modules/strip-loader/lib/index.js?strip[]=console.log!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 12 36